"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.vasoreactivityTestMessages = exports.VasoreactivityTest = void 0;
const schema_1 = require("../../../schema");
var VasoreactivityTest;
(function (VasoreactivityTest) {
    VasoreactivityTest["YES"] = "YES";
    VasoreactivityTest["NO"] = "NO";
})(VasoreactivityTest || (exports.VasoreactivityTest = VasoreactivityTest = {}));
exports.vasoreactivityTestMessages = {
    [VasoreactivityTest.YES]: {
        id: "htx.currentCardiologicalState.rightHeartCatheterization.vasoreactivityTest.YES",
        defaultMessage: "Igen"
    },
    [VasoreactivityTest.NO]: {
        id: "htx.currentCardiologicalState.rightHeartCatheterization.vasoreactivityTest.NO",
        defaultMessage: "Nem"
    }
};
const vasoreactivityTest = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(VasoreactivityTest.YES),
    schema_1.Schema.singleChoiceItem(VasoreactivityTest.NO)
])
    .default(VasoreactivityTest.NO)
    .interpretation({ vocab: "htx", code: "vasoreactivity_test" })
    .tag({ vocab: "snomed", code: "712756001" })
    .tag({ vocab: "snomed", code: "65677008" })
    .tag({ vocab: "snomed", code: "243806009" })
    .tag({ vocab: "loinc", code: "78930-5" });
const rrsValue = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({ vocab: "htx", code: "rrs" })
    .tag({ vocab: "snomed", code: "716579001" })
    .tag({ vocab: "loinc", code: "8480-6" });
const rrsPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({
    vocab: "htx",
    code: "systolic_blood_pressure_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "716579001" })
    .tag({ vocab: "snomed", code: "723279008" }));
const rrs = schema_1.Schema.object()
    .default({})
    .properties({ value: rrsValue, postVrt: rrsPostVrt });
const hrValue = schema_1.Schema.number()
    .optional()
    .unit("/perc")
    .interpretation({ vocab: "htx", code: "hr" })
    .tag({ vocab: "snomed", code: "364075005" })
    .tag({ vocab: "loinc", code: "8867-4" });
const hrPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("/perc")
    .interpretation({
    vocab: "htx",
    code: "heart_rate_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "364075005" })
    .tag({ vocab: "snomed", code: "723279008" }));
const hr = schema_1.Schema.object()
    .default({})
    .properties({ value: hrValue, postVrt: hrPostVrt });
const cvpValue = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({ vocab: "htx", code: "cvp" })
    .tag({ vocab: "snomed", code: "71420008" })
    .tag({ vocab: "loinc", code: "60985-9" });
const cvpPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({
    vocab: "htx",
    code: "central_venous_pressure_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "71420008" })
    .tag({ vocab: "snomed", code: "723279008" }));
const cvp = schema_1.Schema.object()
    .default({})
    .properties({ value: cvpValue, postVrt: cvpPostVrt });
const svO2Value = schema_1.Schema.number()
    .optional()
    .unit("%")
    .interpretation({ vocab: "htx", code: "sv02" })
    .tag({ vocab: "snomed", code: "442349007" })
    .tag({ vocab: "loinc", code: "2711-0" });
const svO2PostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("%")
    .interpretation({
    vocab: "htx",
    code: "venous_oxygen_saturation_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "442349007" })
    .tag({ vocab: "snomed", code: "723279008" }));
const svO2 = schema_1.Schema.object()
    .default({})
    .properties({ value: svO2Value, postVrt: svO2PostVrt });
const rvpsValue = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({ vocab: "htx", code: "rvps" })
    .tag({ vocab: "snomed", code: "276772001" })
    .tag({ vocab: "loinc", code: "8432-7" });
const rvpsPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({
    vocab: "htx",
    code: "right_ventricular_systolic_pressure_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "276772001" })
    .tag({ vocab: "snomed", code: "723279008" }));
const rvps = schema_1.Schema.object()
    .default({})
    .properties({ value: rvpsValue, postVrt: rvpsPostVrt });
const rvpdValue = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({ vocab: "htx", code: "rvpd" })
    .tag({ vocab: "snomed", code: "276773006" })
    .tag({ vocab: "loinc", code: "8377-4" });
const rvpdPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({
    vocab: "htx",
    code: "right_ventricular_diastolic_pressure_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "276773006" })
    .tag({ vocab: "snomed", code: "723279008" }));
const rvpd = schema_1.Schema.object()
    .default({})
    .properties({ value: rvpdValue, postVrt: rvpdPostVrt });
const rvpmValue = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({ vocab: "htx", code: "rvpm" })
    .tag({ vocab: "snomed", code: "276756009" })
    .tag({ vocab: "loinc", code: "8406-1" });
const rvpmPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({
    vocab: "htx",
    code: "right_ventricular_pressure_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "276756009" })
    .tag({ vocab: "snomed", code: "723279008" }));
const rvpm = schema_1.Schema.object()
    .default({})
    .properties({ value: rvpmValue, postVrt: rvpmPostVrt });
const papsValue = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({ vocab: "htx", code: "paps" })
    .tag({ vocab: "snomed", code: "250768007" })
    .tag({ vocab: "loinc", code: "8440-0" });
const papsPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({
    vocab: "htx",
    code: "pulmonary_artery_systolic_pressure_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "250768007" })
    .tag({ vocab: "snomed", code: "723279008" }));
const paps = schema_1.Schema.object()
    .default({})
    .properties({ value: papsValue, postVrt: papsPostVrt });
const papdValue = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({ vocab: "htx", code: "papd" })
    .tag({ vocab: "snomed", code: "250769004" })
    .tag({ vocab: "loinc", code: "8385-7" });
const papdPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .interpretation({
    vocab: "htx",
    code: "pulmonary_artery_diastolic_pressure_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "250769004" })
    .tag({ vocab: "snomed", code: "723279008" }));
const papd = schema_1.Schema.object()
    .default({})
    .properties({ value: papdValue, postVrt: papdPostVrt });
const mpapValue = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({ vocab: "htx", code: "mpap" })
    .tag({ vocab: "snomed", code: "250770003" })
    .tag({ vocab: "loinc", code: "8414-5" });
const mpapPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({
    vocab: "htx",
    code: "pulmonary_artery_mean_pressure_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "250770003" })
    .tag({ vocab: "snomed", code: "723279008" }));
const mpap = schema_1.Schema.object()
    .default({})
    .properties({ value: mpapValue, postVrt: mpapPostVrt });
const mpcwpValue = schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({ vocab: "htx", code: "mpcwp" })
    .tag({ vocab: "snomed", code: "118433006" })
    .tag({ vocab: "loinc", code: "8587-8" });
const mpcwpPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("Hgmm")
    .interpretation({
    vocab: "htx",
    code: "pulmonary_artery_wedge_pressure_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "118433006" })
    .tag({ vocab: "snomed", code: "723279008" }));
const mpcwp = schema_1.Schema.object()
    .default({})
    .properties({ value: mpcwpValue, postVrt: mpcwpPostVrt });
const coValue = schema_1.Schema.number()
    .optional()
    .unit("l/min")
    .interpretation({ vocab: "htx", code: "co" })
    .tag({ vocab: "snomed", code: "82799009" })
    .tag({ vocab: "loinc", code: "8741-1" });
const coPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("l/min")
    .interpretation({
    vocab: "htx",
    code: "cardiac_output_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "82799009" })
    .tag({ vocab: "snomed", code: "723279008" }));
const co = schema_1.Schema.object()
    .default({})
    .properties({ value: coValue, postVrt: coPostVrt });
const ciValue = schema_1.Schema.number()
    .optional()
    .interpretation({ vocab: "htx", code: "ci" })
    .tag({ vocab: "snomed", code: "54993008" })
    .tag({ vocab: "loinc", code: "75919-1" });
const ciPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .interpretation({
    vocab: "htx",
    code: "cardiac_index_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "54993008" })
    .tag({ vocab: "snomed", code: "723279008" }));
const ci = schema_1.Schema.object()
    .default({})
    .properties({ value: ciValue, postVrt: ciPostVrt });
const tpgValue = schema_1.Schema.number()
    .optional()
    .interpretation({ vocab: "htx", code: "tpg" })
    .tag({ vocab: "snomed", code: "251086009" });
const tpgPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .interpretation({
    vocab: "htx",
    code: "pulmonary_valve_ventriculoarterial_gradient_post"
})
    .tag({ vocab: "snomed", code: "251086009" })
    .tag({ vocab: "snomed", code: "723279008" }));
const tpg = schema_1.Schema.object()
    .default({})
    .properties({ value: tpgValue, postVrt: tpgPostVrt });
const pvrValue = schema_1.Schema.number()
    .optional()
    .unit("Wood")
    .interpretation({ vocab: "htx", code: "pvr" })
    .tag({ vocab: "snomed", code: "276901002" })
    .tag({ vocab: "loinc", code: "8828-6" });
const pvrPostVrt = schema_1.Schema.ifThen(schema_1.Schema.expression(`{../../vasoreactivityTest} === "YES"`), schema_1.Schema.number()
    .optional()
    .unit("Wood")
    .interpretation({
    vocab: "htx",
    code: "pulmonary_vascular_resistance_post_vasodilatation"
})
    .tag({ vocab: "snomed", code: "276901002" })
    .tag({ vocab: "snomed", code: "723279008" }));
const pvr = schema_1.Schema.object()
    .default({})
    .properties({ value: pvrValue, postVrt: pvrPostVrt });
exports.validator = schema_1.Schema.object()
    .expiration(15552000)
    .default({})
    .sealed(true)
    .properties({
    vasoreactivityTest,
    rrs,
    hr,
    cvp,
    svO2,
    rvps,
    rvpd,
    rvpm,
    paps,
    papd,
    mpap,
    mpcwp,
    co,
    ci,
    tpg,
    pvr
})
    .interpretation({ vocab: "htx", code: "right_heart_catheterization" })
    .tag({ vocab: "snomed", code: "65677008" })
    .tag({ vocab: "loinc", code: "78930-5" })
    .tag({ vocab: "snomed", code: "243806009" });
